"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageDirection = void 0;
/* istanbul ignore file -- no need to test type declarations */
var LanguageDirection;
(function (LanguageDirection) {
    LanguageDirection["AUTO"] = "auto";
    LanguageDirection["LTR"] = "ltr";
    LanguageDirection["RTL"] = "rtl";
})(LanguageDirection = exports.LanguageDirection || (exports.LanguageDirection = {}));
//# sourceMappingURL=language-direction.js.map